import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-list-item',
  styleUrl: 'signet-list-item.scss',
  shadow: true,
})
export class SignetListItem {
  render() {
    return (
      <div class="signet-list-item">
        <slot></slot>
      </div>
    );
  }
}
